// extracted by mini-css-extract-plugin
export default {"imgBox":"Img_imgBox__HImXl","imgBox__img":"Img_imgBox__img__ghJWL"};